import "./style.css"

const ClosePopUpButton = ({ onClose }) => {
	return (
		<div className="closepopUp-button-container">
			<button className="closepopUp-button" onClick={onClose}>Fenster Schließen</button>
		</div>
	)
}

export default ClosePopUpButton;
